import React from 'react';

import './index.scss';

const Hours = () => {
	return (
		<div className='contact-section-wrapper'>
			<h3>Business Hours</h3>
			<div className='contact-card hours-card'>
				<div className='date'>
					<b>Monday</b>
					<b>Tuesday</b>
					<b>Wednesday</b>
					<b>Thursday</b>
					<b>Friday</b>
					<b>Saturday</b>
					<b>Sunday</b>
				</div>
				<div>
					<p>9:45AM - 7:15PM</p>
					<p>9:45AM - 7:15PM</p>
					<p>9:45AM - 7:15PM</p>
					<p>9:45AM - 7:15PM</p>
					<p>9:45AM - 7:15PM</p>
					<p>9:45AM - 7:15PM</p>
					<p>10:00PM - 6:30PM</p>
				</div>
			</div>
		</div>
	);
};

export default Hours;
